import { IFlyexLocation, IFlyexLocationPersistence } from '../interfaces';

export class FlyexLocationMapper {
  public static toDomain(raw: IFlyexLocationPersistence): IFlyexLocation {
    return {
      id: raw.id,
      address: raw.address,
      name: raw.name,
      lat: raw.lat,
      lng: raw.lng,
      mapUrl: raw.map_url,
      scheduleDescription: raw.schedule_description,
    };
  }
}
